import { defineStore } from 'pinia';
import {
    computed, readonly, ref,
    type Ref,
} from 'vue';

type MenuStore = {
    isMenuShown: Readonly<Ref<boolean>>,
    isPopupShown: Readonly<Ref<boolean>>,
    doesMenuHasAnimation: Readonly<Ref<boolean>>,
    doesRequestOverlay: Readonly<Ref<boolean>>,
    showMenu: () => void,
    hideMenu: () => void,
    switchToPopup: () => void,
    disableAnimationUntilShown: () => void,
};

export const useMenuStore = defineStore('menu', (): MenuStore => {
    const isMenuShown = ref(false);
    const isPopupShown = ref(false);
    const doesMenuHasAnimation = ref(false);

    const showMenu = () => {
        isMenuShown.value = true;
        doesMenuHasAnimation.value = true;
    };

    const hideMenu = () => {
        isPopupShown.value = false;
        isMenuShown.value = false;
    };

    const switchToPopup = () => {
        isMenuShown.value = false;
        isPopupShown.value = !isPopupShown.value;
    };

    const disableAnimationUntilShown = () => {
        doesMenuHasAnimation.value = false;
    };

    const doesRequestOverlay = computed<boolean>(() => false);

    return {
        isMenuShown: readonly(isMenuShown),
        isPopupShown: readonly(isPopupShown),
        doesMenuHasAnimation: readonly(doesMenuHasAnimation),
        doesRequestOverlay,
        showMenu,
        hideMenu,
        switchToPopup,
        disableAnimationUntilShown,
    };
});
